<template>
  <el-card class="card linkFormSection">
    <div slot="header" class="linkFormSection__header">
      <strong class="linkFormSection__title">过滤条件</strong>
    </div>

    <p class="dataFormShell__hint">国家与应用/系统版本均为选填；未配置表示不做对应维度过滤。</p>

    <el-form-item label="国家（选填）">
      <div class="dataFilterSection__countryMode">
        <el-switch
          v-model="country.isExclude"
          active-text="不包含国家"
          inactive-text="包含国家"
          :disabled="disabled"
        />
      </div>
      <el-select
        v-model="country.countries"
        class="dataFilterSection__control"
        filterable
        multiple
        placeholder="请选择国家"
        popper-class="linkListFilterDropdown"
        :disabled="disabled"
      >
        <el-option
          v-for="item in countryOptions"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="系统版本（选填）">
      <div class="dataVersionRow">
        <el-input
          v-model="apiVersion.start"
          class="dataVersionRow__input"
          type="number"
          placeholder="开始版本"
          :disabled="disabled"
        />
        <span class="dataVersionRow__sep" aria-hidden="true">—</span>
        <el-input
          v-model="apiVersion.end"
          class="dataVersionRow__input"
          type="number"
          placeholder="结束版本"
          :disabled="disabled"
        />
        <el-input
          v-model="apiVersion.skip"
          class="dataVersionRow__skip"
          placeholder="跳过版本，逗号分隔"
          :disabled="disabled"
        />
      </div>
    </el-form-item>

    <el-form-item label="应用版本（选填）">
      <div class="dataVersionRow">
        <el-input
          v-model="appVersion.start"
          class="dataVersionRow__input"
          type="number"
          placeholder="开始版本"
          :disabled="disabled"
        />
        <span class="dataVersionRow__sep" aria-hidden="true">—</span>
        <el-input
          v-model="appVersion.end"
          class="dataVersionRow__input"
          type="number"
          placeholder="结束版本"
          :disabled="disabled"
        />
        <el-input
          v-model="appVersion.skip"
          class="dataVersionRow__skip"
          placeholder="跳过版本，逗号分隔"
          :disabled="disabled"
        />
      </div>
    </el-form-item>
  </el-card>
</template>

<script>
import { getCountry } from '../../../api/comment'

export default {
  name: 'DataFilterSection',
  props: {
    country: { type: Object, required: true },
    apiVersion: { type: Object, required: true },
    appVersion: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      countryOptions: [],
    }
  },
  created() {
    this.loadCountryOptions()
  },
  methods: {
    loadCountryOptions() {
      getCountry().then((res) => {
        if (res.success) {
          this.countryOptions = res.data || []
        }
      })
    },
  },
}
</script>

<style scoped>
.dataFormShell__hint {
  margin: 0 0 12px;
  font-size: var(--link-text-sm);
  color: var(--link-ink-muted);
  line-height: 1.45;
}

.dataFilterSection__countryMode {
  margin-bottom: 10px;
}

.dataFilterSection__control {
  width: 100%;
}
</style>
